import React from 'react';
import { Tag } from '../../hooks/useTags';
import { TagBooleanItem } from './TagBooleanItem';

export interface TagBooleanValue {
  and: Tag[];
  or: Tag[];
  not: Tag[];
}

interface Props {
  projectId: string;
  value: TagBooleanValue;
  onChange: (value: TagBooleanValue) => void;
}

export function TagBoolean({ projectId, value, onChange }: Props) {
  const emit = (and: Tag[], or: Tag[], not: Tag[]) => onChange({ and, or, not });

  return (
    <div className="tag-boolean">
      <TagBooleanItem projectId={projectId} title="And Tags" tags={value.and} onChange={tags => emit(tags, value.or, value.not)} />
      <TagBooleanItem projectId={projectId} title="Or Tags"  tags={value.or}  onChange={tags => emit(value.and, tags, value.not)} />
      <TagBooleanItem projectId={projectId} title="Not Tags" tags={value.not} onChange={tags => emit(value.and, value.or, tags)} />
    </div>
  );
}
